import { ReactElement } from 'react';

import {
   appendTestableCustomAttribute,
   DocplannerIcon,
   IconSize,
   IconWrapper,
   PatientPortalIcon,
} from '@dreryk/react-components';

import { createAppointmentSourceVisitor, isAppointmentSourceLabelApplicable } from '~libs.shared.appointments';

type AppointmentsTimetableEventAppointmentSourceLabelIconProps = {
   sourceLabel: string | undefined;
};

export const AppointmentsTimetableEventAppointmentSourceLabelIcon = (
   props: AppointmentsTimetableEventAppointmentSourceLabelIconProps
): ReactElement | null => {
   if (!props.sourceLabel || !isAppointmentSourceLabelApplicable(props.sourceLabel)) {
      return null;
   }

   return (
      <span {...appendTestableCustomAttribute('calendareventappointmentsource', props.sourceLabel)}>
         <IconWrapper testId={'appointmentSource'} size={IconSize.SMALLEST}>
            {createAppointmentSourceVisitor(props.sourceLabel)({
               visitDocplanner: () => <DocplannerIcon />,
               visitPatientPortal: () => <PatientPortalIcon />,
               visitEgabinet: () => null,
            })}
         </IconWrapper>
      </span>
   );
};
